import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <h3
                                className={
                                    styles.title +
                                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-10"
                                }
                                >
                                    Remove Passwords From Your Day-To-Day with Passwordless Login
                                </h3>
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <img alt="EngineID App Launch" className={styles.tabletImage} src={ArticleGraphic} />
                                        <p>
                                            One of the common annoyances faced by corporate staff is the constant logging in to different applications during the work-day. These applications have various 
                                            password requirements and before long staff are juggling a number of separate passwords.
                                        </p>
                                        <p>
                                            Constantly entering passwords leads to <b>password fatigue</b>, which in turn leads to poor security practices such as password repetition and easily guessable 
                                            passwords. This opens up your organization to simple automated attacks which compromises your digital assets.
                                        </p>
                                        <p>
                                            The best way to improve your staff login experience and raise your cyber security profile is to eliminate the need for passwords altogether. With EngineID this is possible. 
                                            What’s better, is that with one Passwordless login, staff can access all of their applications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}